var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "adam-header-bar",
        {
          class: [
            { "adam-header-bar--bg-dev": _vm.isDevEnvironment },
            { "adam-header-bar--bg-uat": _vm.isUatEnvironment },
          ],
          attrs: { username: _vm.user.name, emailaddress: _vm.user.email },
          domProps: { showNotifications: false },
          on: {
            "apps-click": _vm.clickDrawer,
            "view-history-click": _vm.redirectToAppStore,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "app-logo",
              attrs: { slot: "headerContent" },
              slot: "headerContent",
            },
            [
              _c("img", {
                attrs: {
                  src: require("adam.ui-core/assets/brand/logo-coode-white.svg"),
                },
              }),
            ]
          ),
          _c(
            "span",
            { attrs: { slot: "headerContent" }, slot: "headerContent" },
            [_c("h4", [_vm._v("MODE Event Management")])]
          ),
          _c(
            "span",
            { attrs: { slot: "profileDetails" }, slot: "profileDetails" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedLanguage,
                      expression: "selectedLanguage",
                    },
                  ],
                  staticClass: "pui-form-type-ahead-input-single-select mb-1",
                  attrs: { id: "language-selection" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedLanguage = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.changeSelectedLanguage,
                    ],
                  },
                },
                _vm._l(_vm.languageOptions, function (lang, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: lang } },
                    [_vm._v(_vm._s(lang))]
                  )
                }),
                0
              ),
              _c(
                "pui-button",
                {
                  staticClass: "profile-action-button",
                  attrs: { state: "secondary", icon: "report" },
                  on: {
                    click: function ($event) {
                      return _vm.sendFeedback()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("sendFeedback")) + " ")]
              ),
              _c(
                "pui-button",
                {
                  staticClass:
                    "profile-action-button profile-action-button--important",
                  attrs: { state: "secondary", icon: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.reportIncident()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("reportIncident")) + " ")]
              ),
              _c(
                "pui-button",
                {
                  staticClass: "profile-action-button",
                  attrs: { icon: "power" },
                  on: {
                    click: function ($event) {
                      return _vm.logOut()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("signOut")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("pui-navigation-toolbar", {
        attrs: { "link-items": _vm.navItems, "action-items": [] },
        on: { "changed:active-route": _vm.handleActiveRoute },
      }),
      _c(
        "app-drawer",
        {
          ref: "appDrawer",
          domProps: {
            data: _vm.applications,
            labels: _vm.getAppDrawerLabels,
            onClick: _vm.handleAppClick,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "app-drawer-logo",
              attrs: { slot: "appLogo" },
              slot: "appLogo",
            },
            [
              _c("img", {
                attrs: {
                  src: require("adam.ui-core/assets/brand/logo-coode-rgb.svg"),
                },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }